import { render } from "./Header-index.vue?vue&type=template&id=4c4274b0&scoped=true"
import script from "./Header-index.vue?vue&type=script&lang=js"
export * from "./Header-index.vue?vue&type=script&lang=js"

import "./Header-index.vue?vue&type=style&index=0&id=4c4274b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c4274b0"]])

export default __exports__